import { Injectable, Injector } from '@angular/core';
import { environment } from '@env';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ConfigurationService } from '@core/services/configuration.service';
import { from, Observable, throwError } from 'rxjs';
import { LocalStorageService } from '@core/services/local-storage.service';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ConnectivityService } from './connectivity.service';
@Injectable({
  providedIn: 'root',
})
export class HttpRequestService {
  apiUrl = '';
  constructor(
    private httpClient: HttpClient,
    private configurationService: ConfigurationService,
    private localStorageService: LocalStorageService,
    private injector: Injector,
    private router: Router,
    private connectivityService: ConnectivityService
  ) {
    this.apiUrl = configurationService.apiUrl;
  }

  public fileRequest(endpoint: string, data?: any): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/api/${endpoint}`, data, {
      headers: {
        Authorization: `Bearer ${this.localStorageService.getItem(
          'token',
          false
        )}`,
      },
    });
  }

  public request(
    method = 'get',
    endpoint: string,
    data?: any,
    authorised: boolean = true
  ): Observable<any> {
    let observable: any;
    const headers = {
      'Content-Type': 'application/json',
      Authorization:
        'Bearer ' + this.localStorageService.getItem('token', false),
    };
    if (!authorised) {
      delete headers.Authorization;
    }
    switch (method) {
      case 'post':
        observable = this.httpClient.post(
          `${this.apiUrl}/api/${endpoint}`,
          data,
          { headers }
        );
        break;
      case 'put':
        observable = this.httpClient.put(
          `${this.apiUrl}/api/${endpoint}`,
          data,
          { headers }
        );
        break;
      case 'delete':
        observable = this.httpClient.delete(`${this.apiUrl}/api/${endpoint}`, {
          headers,
        });
        break;
      default:
        observable = this.httpClient.get(`${this.apiUrl}/api/${endpoint}`, {
          params: data,
          headers,
        });
    }
    return observable.pipe(
      catchError((err) => {
        // console.log('error caught in service');
        if (err.status === 401){
          this.connectivityService.authLogoutSubject.next(true);
          // return throwError(err);
        }else{
          return throwError(err);
        }
      })
    );
  }
}
